// extracted by mini-css-extract-plugin
export var description = "hero-module--description--osBNJ";
export var heroName = "hero-module--heroName--cu7Z6";
export var highlight = "hero-module--highlight--65cMg";
export var subTitle = "hero-module--subTitle--7+-BT";
export var tagline = "hero-module--tagline--U1W5m";
export var title = "hero-module--title--ECmwx";